<app-sidebar class="street-light-planner-sidebar-new">
  <ng-container sidebar-header>
    <div class="header-text">
      <span class="title">{{ 'module.energyMap.streetlightPlanner.streetlightPlannerText' | translate }}</span>
      <span class="step">{{ step }}/{{ maxStep }}</span>
    </div>
    <button class="btn btn-primary btn-close" (click)="triggerClose()">
      <img class="x-icon" alt="close-icon" src="../../../../assets/icons/close-icon-white.svg" />
    </button>
  </ng-container>

  <ng-container sidebar-body [ngSwitch]="scenario.isRecommendation">
    <app-street-light-planner-step1 *ngSwitchDefault [isRecommendation]="isRecommendation" (isRecommendationValueChange)="onRecommendationChange($event)">
    </app-street-light-planner-step1>

    <app-street-light-planner-recommended
      *ngSwitchCase="true"
      [scenario]="scenario"
      (maxStepChange)="updateMaxStep($event)"
      (stepChange)="updateStep($event)"
      (backChange)="updateBack($event)"
      (nextChange)="updateNext($event)"
      (resetEvent)="reset()"
    >
    </app-street-light-planner-recommended>

    <app-street-light-planner-manual
      *ngSwitchCase="false"
      (maxStepChange)="updateMaxStep($event)"
      (stepChange)="updateStep($event)"
      (backChange)="updateBack($event)"
      (nextChange)="updateNext($event)"
      (resetEvent)="reset()"
    >
    </app-street-light-planner-manual>
  </ng-container>

  <ng-container sidebar-footer>
    <button class="btn btn-primary -border-inverted btn-previous" (click)="back()">Zurück</button>
    <button class="btn btn-primary -border-inverted btn-next" (click)="next()">Weiter</button>
  </ng-container>

  <div class="overlay" *ngIf="isLoading">
    <span class="fa fa-spinner fa-spin fa-3x"></span>
  </div>
</app-sidebar>
